import { useIsUnifiedFieldsEnabled } from '@modules/common/hooks';
import { isCommonMetadataField } from '@modules/common/utils';
import { EditRounded } from '@mui/icons-material';
import { Divider, IconButton, Stack, Tooltip } from '@mui/material';
import {
  EqlField,
  PermissionOperation,
  PermissionResource,
} from 'generated/graphql';
import { useIsAuthorized } from '../CanAccess/hooks';

interface EqlFieldCommonMetadataEditButtonProps {
  eqlField: EqlField;
  setShouldOpenUnifiedFieldDrawer: (shouldOpen: boolean) => void;
  setSelectedUnifiedFieldForEdit: (eqlField: EqlField) => void;
}

export const EqlFieldCommonMetadataEditButton = ({
  eqlField,
  setShouldOpenUnifiedFieldDrawer,
  setSelectedUnifiedFieldForEdit,
}: EqlFieldCommonMetadataEditButtonProps) => {
  const isUnifiedFieldsEnabled = useIsUnifiedFieldsEnabled();

  const isCommonMetadata = isCommonMetadataField(eqlField);

  const isAuthorized = useIsAuthorized({
    operation: PermissionOperation.Write,
    resource: PermissionResource.Metadata,
  });

  if (!isCommonMetadata) {
    return null;
  }

  if (!isUnifiedFieldsEnabled) {
    return null;
  }

  if (!isAuthorized) {
    return null;
  }

  return (
    <Stack
      className="EditIconContainer"
      sx={{ opacity: 0 }}
      onClick={(event) => event.stopPropagation()}
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
    >
      <Divider orientation="vertical" flexItem />
      <Tooltip title="Edit this Unified Field" disableInteractive>
        <IconButton
          onClick={() => {
            setShouldOpenUnifiedFieldDrawer(true);
            setSelectedUnifiedFieldForEdit(eqlField);
          }}
        >
          <EditRounded fontSize="small" color="action" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
